export default __webpack_public_path__ + "static/media/bridge_logo.62e25083.svg";